<template>
  <img alt="CenterWell Pharmacy logo" src="./assets/HumanaLogo.png">
  <NuanceChat msg="Welcome to CenterWell Pharmacy"/>
</template>

<script>
import NuanceChat from './components/NuanceChat.vue'

export default {
  name: 'App',
  components: {
    NuanceChat
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
